import type { RileyWalkthrough } from './contracts'

export const WALKTHROUGH_EVENT = 'patchbay:walkthrough-changed'

export type WalkthroughEventDetail = { walkthrough?: RileyWalkthrough | null }

/** Tell the shell that a chat/card response started or advanced a server-owned walk-through. */
export function announceWalkthrough(walkthrough?: RileyWalkthrough | null): void {
  globalThis.dispatchEvent?.(new CustomEvent<WalkthroughEventDetail>(WALKTHROUGH_EVENT, { detail: { walkthrough } }))
}
